const lightPalette = {
  text: {
    primary: '#121312',
    secondary: '#6B6B6B',
    disabled: '#DDDEE0',
  },
  primary: {
    dark: '#3c3c3c',
    main: '#121312',
    light: '#5f6266',
  },
  secondary: {
    dark: '#3c3c3c',
    main: '#3c3c3c',
    light: '#3c3c3c',
    background: '#F1F2F5',
  },
  complementary: {
    light: '#fcff52e1',
    main: '#FCFF52',
  },
  border: {
    main: '#A1A3A7',
    light: '#E1E2EA',
    background: '#F4F4F4',
  },
  error: {
    dark: '#AC2C3B',
    main: '#FF5F72',
    light: '#FFB4BD',
    background: '#FFE6EA',
  },
  success: {
    dark: '#028D4C',
    main: '#00B460',
    light: '#72F5B8',
    background: '#EFFAF1',
  },
  info: {
    dark: '#52BFDC',
    main: '#5FDDFF',
    light: '#B7F0FF',
    background: '#EFFCFF',
  },
  warning: {
    dark: '#C04C32',
    main: '#FF8061',
    light: '#FFBC9F',
    background: '#FFF1E0',
  },
  background: {
    default: '#F4F4F4',
    main: '#F4F4F4',
    paper: '#FFFFFF',
    light: '#ECF0F7',
  },
  backdrop: {
    main: '#636669',
  },
  logo: {
    main: '#121312',
    background: '#EEEFF0',
  },
  static: {
    main: '#121312',
    secondary: '#eeeff0;',
  },
}

export default lightPalette
